import { VUEX_STORAGE_KEY } from "@/utils";
import createMultiTabState from "vuex-multi-tab-state";
import { Store } from "vuex";

// This is a global variable from webpack. It has the package.json version with the git tag version setted.
declare const IW_VERSION: string;

/**
 * Adds createMultiTabState plugin to the store passed as param after version info is fetched from the node layer
 * hooks are setup to clean application state every time the git hash changes for IW
 * @param store get's passed to the plugin
 */
export const addStoragePlugin = (store: Store<unknown>): void => {
  createMultiTabState({
    key: VUEX_STORAGE_KEY,
    //This hook excecutes every time the localStore is copied over the store
    onBeforeReplace: state => {
      if (state.__gitTag !== IW_VERSION) {
        //returning false will not execute store.replaceState then state is kept only with default values
        return false;
      }
      //returning the state will replace store values with localstorage (state)
      return state;
    },
    //This hook excecutes every time the store is copied to localStore
    onBeforeSave: state => {
      //gitTag is updated with the current app version
      if (state.__gitTag !== IW_VERSION) {
        state.__gitTag = IW_VERSION;
      }
      return state;
    }
  })(store);
};
